import type Rollbar from 'rollbar'

export class ClientLogger {
  constructor(private rollbar: Rollbar) {
    if (!rollbar) {
      throw new Error('No rollbar instance was set')
    }
  }

  public log = (args: Array<Rollbar.LogArgument>) => {
    if (this.rollbar) this.rollbar.log(...args)
    // eslint-disable-next-line no-console
    else console.log(...args)
  }

  public debug = (args: Array<Rollbar.LogArgument>) => {
    if (this.rollbar) this.rollbar.debug(...args)
    // eslint-disable-next-line no-console
    else console.debug(...args)
  }

  public info = (...args: Array<Rollbar.LogArgument>) => {
    if (this.rollbar) this.rollbar.info(...args)
    // eslint-disable-next-line no-console
    else console.info(...args)
  }

  public warn = (...args: Array<Rollbar.LogArgument>) => {
    if (this.rollbar) this.rollbar.warn(...args)
    // eslint-disable-next-line no-console
    else console.warn(...args)
  }

  public warning = (...args: Array<Rollbar.LogArgument>) => {
    if (this.rollbar) this.rollbar.warning(...args)
    // eslint-disable-next-line no-console
    else console.warn(...args)
  }

  public error = (...args: Array<Rollbar.LogArgument>) => {
    if (this.rollbar) this.rollbar.error(...args)
    // eslint-disable-next-line no-console
    else console.error(...args)
  }

  public critical = (...args: Array<Rollbar.LogArgument>) => {
    if (this.rollbar) this.rollbar.critical(...args)
    // eslint-disable-next-line no-console
    else console.error(...args)
  }
}
